import React, { useState, useEffect, useRef, forwardRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Grid, CircularProgress, IconButton, ListItemIcon, ListItemText, MenuItem, Menu,
        Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button,Tooltip} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';


// Icons
import {
    Add as AddIcon,
    MoreVert as MoreVertIcon,
    CardMembership as CardMembershipIcon,
    DateRange as DateRangeIcon,
    History as HistoryIcon
} from '@material-ui/icons'

import useStyles from './styles';
import config from '../../config';
import { sendNotification } from "../../context/UserContext";
import CreateSite from '../../components/Site/CreateSite';

const Sites = forwardRef((props, ref) => {
  const classes = useStyles();
  const history = useHistory();

  // local
  var [data, setData] = useState([]);
  var [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  var [isLoading, setIsLoading] = useState(false);
  const delayedOnSearchKey = useRef(debounce(q => onSearchKey(q), 500)).current;

  const [openCreateSiteDialog, setOpenCreateSiteDialog] = useState(false);
  const createSiteRef = useRef(null);
  const [isCreateSiteValid, setIsCreateSiteValid] = useState(false);
  const [isCreatingSite, setIsCreatingSite] = useState(false);
  const [createdSite, setCreatedSite] = useState({
    id: -1,
    customer_id: -1,
    name: null,
    code: null,
    contact: null,
    phone: null,
    email: null,
    address: null,
    notes: null,
    mapurl: null,
    active: true
  });

  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:focus': {
          backgroundColor: theme.palette.primary.main,
          '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
            color: theme.palette.common.white,
          },
        },
      },
    }))(MenuItem);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);


  const columns = [
    { label: 'ID', name: 'id', options: {filter: false}},
    { label: 'Name', name: 'name', options: {filter: true, display: false, download: true} },
    {
        name: "name_address",
        label: "Name and Address",
        options: {
            filter: false,
            sort: true,
            searchable: false,
            download: false,
            customBodyRender: (value, tableMeta) => {
                return (<div>{tableMeta.rowData[1]} <br/>{tableMeta.rowData[2]}</div>);
            }
        }
    },
    { label: 'Code', name: 'code', options: {filter: true}},
    { label: 'Active',
      name: 'active',
      options: {
        filter: true,
        filterList: (localStorage.getItem('sites_filter_list') === undefined || localStorage.getItem('sites_filter_list') === null || JSON.parse(localStorage.getItem('sites_filter_list'))[4].length === 0) ? [] : JSON.parse(localStorage.getItem('sites_filter_list'))[4],
        customFilterListOptions: {
                  render: v => {
                    return `Active: ${v}`;
                  },
        }
      }
    },
    { label: 'Address', name: 'address', options: {filter: false, display: false, download: true} },
    { label: 'Action',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return (<div>
              <IconButton color="primary"
                          component="span"
                          onClick={handleClick}>
                  <MoreVertIcon />
              </IconButton>
              <StyledMenu
                  id="customized-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}

                >
                  <StyledMenuItem onClick={bookRetest}>
                    <ListItemIcon>
                      <DateRangeIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Book Retest" />
                  </StyledMenuItem>
                  <StyledMenuItem onClick={downloadHistory}>
                    <ListItemIcon>
                      <HistoryIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Download History" />
                  </StyledMenuItem>
                  <StyledMenuItem onClick={downloadPricingHistory}>
                    <ListItemIcon>
                      <HistoryIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Download Pricing History" />
                  </StyledMenuItem>
                  <StyledMenuItem onClick={viewSiteForecast}>
                    <ListItemIcon>
                      <CardMembershipIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="View Forecast" />
                  </StyledMenuItem>
                </StyledMenu>


                </div>
            );
          }
        }
      }
  ];

  function bookRetest() {
      window.open(
      `${config.adminApi}/#/app/site/retest/book/${data[selectedRowIndex].id}`,
      '_blank'
      );
      handleClose();
  }

  const downloadHistory = () => {
    window.open(`${config.clientApi}/reports/audit/site?id=${data[selectedRowIndex].id}`,'_blank');
  }

  const downloadPricingHistory = () => {
    window.open(`${config.clientApi}/reports/audit/pricing/site?id=${data[selectedRowIndex].id}`,'_blank');
  }

  const getMuiTheme = () => createMuiTheme({
    palette: {
     primary: {
       main: '#FFCA06',
     },
   },
     overrides: {
       MUIDataTableFilter: {
         root: {
           width: '500px',
         }
       },
       MuiTableCell: {
           root: {
               padding: '0px 16px',
           },
       },
     }
   });

   const handleClick = (event) => {
     setAnchorEl(event.currentTarget);
     setIsMenuOpen(true);
   };

   const handleClose = () => {
     setAnchorEl(null);
     setSelectedRowIndex(-1);
     setIsMenuOpen(false);
   };


    useEffect(() => {
       let mounted = true;
       const fetchData = async() => {
         setIsLoading(true);
         const response = await ttAPI.getCustomerSites(props.id);
         if(mounted){
            setData(response);
            setIsLoading(false);
         }
       };
       fetchData();
       // pre-set customer id to new site
       setCreatedSite({
         ...createdSite,
         customer_id: props.id,
       });

       return () => mounted = false;

    }, []);

    async function refreshData() {
      const response = await ttAPI.getCustomerSites(props.id);
      setData(response);
    }

    async function onSearchKey(key) {
      if (key !== undefined && key !== null && key !== '' && key.length >= 3) {
        const response = await ttAPI.getSitesByKey(key, props.id);
        if (response !== null) {
            setData(response);
        }
        else {
            setData([]);
        }
      }
      else {
        refreshData();
      }
    };

    const handleCloseCreateSiteDialog = () => {
        setOpenCreateSiteDialog(false);
    };

    function onCreateSiteFormUpdated(isValid) {
      setIsCreateSiteValid(isValid);
    }

    function onCreateSiteUpdated(site) {
    }

    function onSiteCreated(sie, isUpdate, siteId) {
      sendNotification('success', isUpdate ? 'Success - Site Updated.' : 'Success - Site Created.', classes);
      history.push({pathname:`/app/site/edit/${siteId}`,
                                       state:{siteId: siteId}
                                     });
    }

    function handleOpenCreateSiteDialog() {
      setOpenCreateSiteDialog(true);
    }

    function createSite() {
      if (createSiteRef !== null && createSiteRef.current !== null) {
          createSiteRef.current.saveSite();
      }
    }

    function viewSiteForecast() {
      window.open(
      `${config.clientApi}/reports/site/forecast?site_id=${data[selectedRowIndex].id}`,
      '_blank'
      );
      handleClose();
    }

  return (
    <>
      <Grid container spacing={4}>
      <Grid item xs={12}>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={data !== undefined && data !== null ? data.map(item => {
                return [
                    item.id,
                    item.name,
                    item.address,
                    item.code,
                    item.active ? 'YES' : 'NO',
                    item.address
                ]
            }) : []}
            columns={columns}
            options={{
              fixedHeader: true,
              tableBodyHeight: '70vh',
              filterType: "multiselect",
              searchOpen: true,
              print: false,
              viewColumns: true,
              selectableRows: 'none',
              rowsPerPageOptions: [10,15,20,50,100],
              rowsPerPage: 100,
              textLabels: { body: { noMatch : isLoading ? <CircularProgress size={25} color={'inherit'} /> : 'Sorry, no matching records found.' }, },
              downloadOptions: {filterOptions:{useDisplayedColumnsOnly: false, useDisplayedRowsOnly: false}},
              customToolbar: () => {
                return (
                   <Tooltip title="Create Site">
                    <IconButton onClick={handleOpenCreateSiteDialog}><AddIcon /></IconButton>
                    </Tooltip>
                );
              },
              /*onRowClick: row => window.open(
                       `${config.adminApi}/#/app/site/edit/${row[0]}`,
                       '_blank'
                     ),*/
               onSearchChange: (searchText) => {
                 delayedOnSearchKey(searchText);
               },
               customSearch: (searchQuery, currentRow, columns) => {
                  return data.find(c=> c.id === currentRow[0]) !== undefined;
               },
               onSearchClose: () => {
                  refreshData();
               },
               onCellClick: (col, cellMeta) => {
                 //console.log('selectedRowIndex set to ', cellMeta.dataIndex, isMenuOpen)
                 if (!isMenuOpen) {
                   setSelectedRowIndex(cellMeta.dataIndex);
                   if (cellMeta.colIndex !== columns.length - 1 ) {
                       window.open(
                              `${config.adminApi}/#/app/site/edit/${data[cellMeta.dataIndex].id}`,
                              '_blank'
                            )
                      /*history.push({pathname:`/app/site/edit/${data[cellMeta.dataIndex].id}`,
                                                     state:{siteId: data[cellMeta.dataIndex].id}
                                                   });*/
                   }
                 }
               },
              onTableInit: (action, tableState) => {
                if (localStorage.getItem('sites_filter_list') === undefined || localStorage.getItem('sites_filter_list') === null || JSON.parse(localStorage.getItem('sites_filter_list'))[4].length === 0) {
                   tableState.filterList[4] = ['YES'];
                   localStorage.setItem('sites_filter_list', JSON.stringify(tableState.filterList));
                 }
             },
            }}
          />
        </MuiThemeProvider>
      </Grid>
      </Grid>

      <Dialog open={openCreateSiteDialog} onClose={handleCloseCreateSiteDialog} disableBackdropClick={true} maxWidth="lg"

          PaperProps={{
            style: {
              boxShadow: 'none',
              width: '100%'
            },
          }}
      >
        <DialogTitle className={classes.title}>CREATE SITE</DialogTitle>
            <DialogContent>
                <DialogContentText>
                  <CreateSite ref={createSiteRef}
                            createdSite={createdSite}
                            onFormUpdated={onCreateSiteFormUpdated}
                            onSiteUpdated={onCreateSiteUpdated}
                            onSiteCreated={onSiteCreated}/>
            </DialogContentText>

        </DialogContent>
        <DialogActions>
            <Button onClick={handleCloseCreateSiteDialog}>
              Cancel
            </Button>
            <Button onClick={createSite} disabled={isCreatingSite || !isCreateSiteValid}>
              {isCreatingSite && <span><CircularProgress size={25} color={'inherit'} /> Creating Site...</span>}
              {!isCreatingSite && <span>CREATE</span>}
            </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

export default Sites;
